export enum TagMaterialType {
    'pic_static_sticker' = 'pic_static_sticker',
    'pic_text' = 'pic_text',
    'pic_bg' = 'pic_background',
}
